module.exports = __webpack_public_path__ + "img/enugu-shield.fc1fa5a4.png";